import { useEffect, useState } from "react";
import { motion } from "framer-motion";

export default function LiquidBackground() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  if (!mounted) return null;

  return (
    <div style={{ position: "absolute", inset: 0, overflow: "hidden", zIndex: 0, pointerEvents: "none", background: "transparent" }}>
      {/* Large Blurred Blobs */}
      <motion.div
        animate={{
          x: [0, 100, -50, 0],
          y: [0, -80, 100, 0],
          scale: [1, 1.2, 0.9, 1],
        }}
        transition={{ duration: 15, repeat: Infinity, ease: "linear" }}
        style={{
          position: "absolute", top: "10%", left: "10%",
          width: "60vw", height: "60vw",
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(217,79,0,0.15) 0%, transparent 70%)",
          filter: "blur(100px)",
        }}
      />
      
      <motion.div
        animate={{
          x: [0, -120, 80, 0],
          y: [0, 100, -60, 0],
          scale: [1, 0.8, 1.1, 1],
        }}
        transition={{ duration: 18, repeat: Infinity, ease: "linear", delay: 2 }}
        style={{
          position: "absolute", bottom: "10%", right: "10%",
          width: "50vw", height: "50vw",
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(255,140,66,0.1) 0%, transparent 70%)",
          filter: "blur(120px)",
        }}
      />

      <motion.div
        animate={{
          x: [0, 150, -100, 0],
          y: [0, 150, 100, 0],
        }}
        transition={{ duration: 25, repeat: Infinity, ease: "linear", delay: 5 }}
        style={{
          position: "absolute", top: "40%", left: "30%",
          width: "40vw", height: "40vw",
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(217,79,0,0.08) 0%, transparent 70%)",
          filter: "blur(80px)",
        }}
      />

      {/* Glassy overlay */}
      <div style={{ position: "absolute", inset: 0, backdropFilter: "none", pointerEvents: "none" }} />
    </div>
  );
}
